export const initialAuthState = {
  isInitialized: false,
  isAuthenticated: false,
  error: undefined,
}
